/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */

const data = {
    header: 'Affiliate Program',
    about_us: {
        left_block: {
            title: 'About Us',
            description: [
                {
                    des: 'Do you own or operate a small business or medium-sized business Web site, or even a personal or hobby Web site or blog? Join our FREE online Affiliate Program, and make extra money by selling plants.com products right on your site! You’ll help your site’s visitors connect with the people in their lives during special holidays and occasions—and at the same time you’ll earn 6% of all sales that come through your site.',
                },
                {
                    des: 'Plants.com offers fast and easy plants delivery on a huge selection of play types. You can offer your site visitors plant care tips, tricks, and tools, everything they need to keep their plants happy and healthy!.',
                },
                {
                    des: 'And it couldn’t be easier. After you sign up, you’ll have your own Affiliate Management account, where you can create links to the plants.com home page or to any product page. All you need to do is put these links on your site, sit back, and watch the money roll in!',
                },
                {
                    des: 'We believe our affiliates to be one of our biggest strengths and we’ll make certain that you, as an affiliate, are provided with the ultimate service. See below to get more in-depth information about our program. You can read our Affiliate Program’s frequently asked questions and read information on how to join our Affiliate Program. Or, if you’re already an affiliate, you can access your Affiliate Program account now.',
                },
            ],
        },
        right_block: {
            title: 'Web Site Owners, Join Now For FREE',
            button: {
                title: 'Apply',
                link: 'https://app.impact.com/campaign-promo-signup/plantscom.brand?execution=e7s1',
            },
            bottom_title: 'Benefits of Joining',
            description: [
                {
                    des: 'Earn 6% commission on your sales!',
                },
                {
                    des: '10 day return cookie',
                },
                {
                    des: 'Dedicated account management',
                },
                {
                    des: 'Regularly refreshed offers and creative',
                },
                {
                    des: 'Quarterly newsletter communication',
                },
                {
                    des: 'High-converting links and products with a high order value',
                },
            ],
        },
    },
    about_program: {
        left_block: {
            title: 'About the Program',
            img: 'https://cdn1.1800flowers.com/wcsstore/Flowers/images/group.svg',
            description: [
                {
                    des: 'Earn revenue by joining our online affiliate program and promoting plants.com on your website. Our program will earn you 6% commission on every sale referred from your site.',
                },
                {
                    des: 'We provide you with all of the tools you need to promote us on your website (banners, text links, product images, video, content & more) and we handle all the ordering, shipping, and billing processes. In addition, there is no charge to join our affiliate network.',
                },
            ],
            list: [
                {
                    li: '6% commission on sales',
                },
                {
                    li: '10 day cookie/return days',
                },
            ],
        },
        right_block: {
            title: 'How to Join',
            img: 'https://cdn1.1800flowers.com/wcsstore/Flowers/images/book.svg',
            description: 'Simply fill out our online registration form to send your already established website URL to us for approval. Once reviewed you will receive an automatic email regarding your approval status. If you have any questions or concerns regarding your status, please contact us here',
            button: {
                title: 'Apply',
                link: 'http://app.impact.com/campaign-promo-signup/plantscom.brand?execution=e2s1',
            },
            here_link: 'https://app.impact.com/campaign-promo-signup/plantscom.brand',
        },
    },
    terms_condition: {
        title: 'Terms & Conditions',
        description: ' This Affiliate Program Agreement (“Agreement”) contains the complete terms and conditions that apply to your participation in the plants.com. Affiliate Program and the establishment of links from your web site to the plants.com web site located at “www.plants.com”(the “Web Site”). You may also be referred to herein as “PARTICIPANT”, “You” or “Party”. Plants.com may also be referred to as “We” or “Us”.',
        program_term: [{
            title: 'The Affiliate Program:',
            description: '(a) As a PARTICIPANT, we will make available to you via the Web Site a variety of graphic, product, textual and other links as determined by plants.com (each of these links sometimes being referred to herein as “Links” or, individually, as a “Link”), which, subject to the terms and conditions of this Agreement, you may display as often and in as many areas of your web site as you desire. The Links will serve to identify your site as a PARTICIPANT of our Affiliate Program and will establish a link from your site to the Web Site for your participation in the Affiliate Program. You agree that you will display on your Web Site only those Links that are provided to you by plants.com through the Impact Radius Network. (b) To commence the process of enrolling as a PARTICIPANT in the Affiliate Program, you will submit an Enrollment Application via our Web Site or as otherwise authorized by plants.com. We will evaluate your application and notify you of your acceptance or rejection; which determination shall be in our sole discretion.',
        },
        {
            title: 'Term:',
            description: '(a) This Agreement is conditioned upon and will become effective on our acceptance of your Enrollment Application and your acceptance of the terms of this Agreement. By joining or participating in the Affiliate Program you are acknowledging that You have read this Agreement and are agreeing to abide by all the terms of this Agreement, which may be amended from time to time in the sole discretion of plants.com. We will notify You of any amendment by posting a notice on the Web Site or, in our sole discretion, by E-mail and Your continued participation in the Affiliate Program after such notice is posted or sent via E-mail shall constitute your binding and legally enforceable agreement to such amendment and acceptance of the Agreement as amended. Either party may terminate this Agreement at any time, with or without cause by giving the other party notice of termination. The first twelve months following the date this Agreement becomes effective and every twelve months thereafter that this Agreement remains in full force and effect are each a “Term Year”. You fully understand that this Agreement creates legally binding obligations on Your part. (b) PARTICIPANT is only eligible to earn commissions on sales which are completed during the term of this Agreement, and commissions earned through the date of termination will be payable only if the related purchases are not canceled or returned. Plants.com may withhold PARTICIPANT’S final payment for a reasonable time to ensure that the correct amount is paid.',
        }],
    },
    faq: {
        title: 'Frequently Asked Questions',
        left_block: [{
            title: 'What is the plants.com Commission + Affiliate Network?',
            description: 'The plants.com Affiliate Program is a fast and easy way to add e-commerce to your web site and start generating revenue by promoting a highly regarded brand. If you have a web site, you can join the program and earn money by promoting any of our products from your site using the banner links we provide. Each time a visitor clicks from your site to the plants.com website and makes a purchase, you earn commission on that sale.',
        },
        {
            title: 'Will I be given commission for driving sales to a store, or by phone?',
            description: 'The affiliate program is only an online revenue driving program; everything is tracked via online links through Impact Radius. Unfortunately we cannot properly track referrals from your website to the phone or stores.',
        },
        {
            title: 'What is involved after joining & who is Impact?',
            description: 'After your application has been approved, you will receive an e-mail containing your username and password for Impact (our 3rd party tool that tracks sales & hosts creative). You will also be given detailed instructions on how to begin pulling our links & offers from Impact to upload on your site.',
        },
        {
            title: 'Does plants.com create a website for me?',
            description: 'No, you will need to already have an established website. There are many sources on the internet and web hosting companies that can help you design one to your liking.',
        }],
        right_block: [
            {
                title: 'Can I bid on plants.com trademarked terms on search engines?',
                description: 'We do not allow our affiliates to bid on our branded terms, misspellings of, or derivatives of the brand name. We also do not allow affiliates to use the trademarked name as part of the display URL.',
            },
            {
                title: 'Where can I find the newest offers to place on my site?',
                description: 'You can find the latest offers to use within Impact. Each month you will receive a newsletter with links to our newest seasonal & holiday offers. Affiliates must update banners & links on their site on an on-going basis to be sure consumers have the most up to date offers. DRM (Dynamic Rich Media) links are available.',
            },
            {
                title: 'Who does plants.com want as affiliates?',
                description: 'We encourage all site owners that are looking to generate revenue through their website to apply to our program. However, before you can participate in our program, we will need to approve your site. Mainly we look for sites that: are aesthetically pleasing, and a site our target audience visits, does not display content that may be deemed pornographic or offensive, and are up and fully functional. We will not approve: sites that are down or are under construction, display of coupon codes which are not provided by the Affiliate Management Team (without prior permission), and other exceptions may apply.',
            },
            {
                title: 'Can I change the plants.com logo or alter the name in any way?',
                description: 'Trademarks may not be altered, modified, amended, or changed in any way. You are only entitled to use the Marks to the extent that this Agreement remains in full force and effect. The use of any such Marks requires the prior written approval of plants.com in all instances.',
            },
        ],
    },
    contact_us: {
        title: 'Contact Us',
        bottom_block:
            {
                title: 'Business Gift Services',
                description: ' Full-service support for medium, large, and enterprise companies and organizations with all of their corporate gifting needs.',
                link: 'Website: <a href="/corporate-gifting-details">https://www.plants.com/corporate-gifting-details</a>',
            },
    },
};
export default data;
